import React, {useState, useEffect, useRef} from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import staff1 from '../../../../images/staff/member_2.png';
import DatePicker from "react-multi-date-picker";
import $ from 'jquery';
import staff2 from '../../../../images/staff/member_1.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import axios from 'axios';

const TeamComparison = ({ show, onClose }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [yeardisplay, setyeardisp] = useState(new Date());
    const [daysInMonth, setDaysInMonth] = useState(31);
    const [salesData, setSalesData] = useState([]);

    const tableRef = useRef(null);

    const [hasFetched, setHasFetched] = useState(false);   

    // page table data fetch
    const fetchData = () => {
        const params = {
            month: yeardisplay.getMonth() + 1,
            year: yeardisplay.getFullYear(),
            branch_id: branch_id
        };
        axios.get(`${baseURL}/team_management/monthly_comparison`, { params: params })
            .then(response => {
                const { data, days_in_month } = response.data;
                setDaysInMonth(days_in_month);
                setSalesData(data);
                // setData(response.data.data);
                // setresp(response.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    const getDayName = (day) => {
        return new Date(yeardisplay.getFullYear(), yeardisplay.getMonth(), day).toLocaleString('en-US', {
        weekday: 'short',
        });
    };

    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }

    useEffect(() => {
        softRefresh();
        // fetchData();
    }, [yeardisplay, branch_id]);

    useEffect (() => {
        console.log(salesData);
    }, [salesData]);

    useEffect(() => {
        if(hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    return (

          
        <Modal show={show} size="xl">
            <style>
                {`
                    .scrollable-table-wrapper {
                        overflow-x: auto;
                        width: 100%;
                    }

                    table {
                        border-collapse: separate;
                        border-spacing: 0;
                    }

                    /* Sticky column for both thead and tbody */
                    .sticky-col {
                        position: sticky;
                        left: 0;
                        z-index: 2;
                        background: #ffffff; /* white column background */
                    }

                    /* Sticky header column higher */
                    thead .sticky-col {
                        background: #025D3A;
                        color: #fff;
                        z-index: 3;
                    }

                    /* Force each row's sticky column to cover background */
                    tbody .sticky-col {
                        background: #ffffff; /* or match table row color */
                    }

                    /* Normal tbody row background to avoid transparency issues */
                    tbody tr td {
                        background: #ffffff; /* or alternate stripe colors */
                    }

                    /* Optional stripe styling if you want alternate rows */
                    tbody tr:nth-child(even) td {
                        background: #f7f7f7;
                    }
                `}
            </style>
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Team Promise Vs Monthly Conversion</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row mb-4'>
                        <div className='col-lg-10 d-flex flex-row align-items-center gap-2'>
                            <div className='d-flex flex-row align-items-center justify-content-start gap-2'>
                                <label className="py-3 px-3 text-danger rounded" style={{backgroundColor: '#4DB6AC'}}>
                                    <span></span>
                                </label>
                                <label className='fw-semibold text-black fs-6'>Promise</label>
                            </div>
                            <div className='d-flex align-items-center jsutify-content-start gap-2'>
                                <label className="py-3 px-3 text-danger rounded" style={{backgroundColor: '#43A047'}}>
                                    <span></span>
                                </label>
                                <label className='fw-semibold text-black fs-6'>Promise Keeper</label>
                            </div>
                            <div className='d-flex align-items-center jsutify-content-start gap-2'>
                                <label className="py-3 px-3 text-danger rounded" style={{backgroundColor: '#F9A825'}}>
                                    <span></span>
                                </label>
                                <label className='fw-semibold text-black fs-6'>Promise Achiever</label>
                            </div>
                            <div className='d-flex align-items-center jsutify-content-start gap-2'>
                                <label className="py-3 px-3 text-danger rounded" style={{backgroundColor: '#D32F2F'}}>
                                    <span></span>
                                </label>
                                <label className='fw-semibold text-black fs-6'>Promise Breaker</label>
                            </div>
                            <div className='d-flex align-items-center jsutify-content-start gap-2'>
                                <label className="py-3 px-3 text-danger rounded" style={{backgroundColor: '#B0BEC5'}}>
                                    <span></span>
                                </label>
                                <label className='fw-semibold text-black fs-6'>No Promise</label>
                            </div>
                        </div>
                        <div className='col-lg-2 mb-2'>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker format="MMM-YYYY" value={yeardisplay} calendarPosition="top" mode="single" onlyMonthPicker={true} minDate={new Date(1900, 0, 1)}  maxDate={new Date()} onChange={(date) => setyeardisp(new Date(date))} />
                            </div>
                        </div>
                    </div>
                    <div className='row mb-4'>
                        <div className="table-container mb-4 scroll-table-wrapper">
                            {hasFetched && (
                                <table ref={tableRef} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                    <thead>
                                        <tr className="text-start align-middle fw-bold fs-6 gs-0 bg-primary">
                                        <th className="min-w-80px px-2 sticky-col">Sales Person</th>
                                        {[...Array(daysInMonth)].map((_, i) => {
                                            const date = (i + 1).toString().padStart(2, '0');
                                            const dayName = getDayName(i + 1);
                                            return (
                                            <th key={i} className="min-w-80px px-1 text-center">
                                                {date}-{dayName}
                                            </th>
                                            );
                                        })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salesData.map((person, idx) => (
                                            <tr key={idx}>
                                                <td className="min-w-80px px-2 sticky-col">
                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                        <LightGallery speed={500} plugins={[] /* add plugins here if needed */}>
                                                        <div data-src={person.image} className="border rounded px-1 py-0">
                                                            <img
                                                            src={person.image}
                                                            alt={person.name}
                                                            className="cursor-pointer w-60px h-60px"
                                                            />
                                                        </div>
                                                        </LightGallery>
                                                        <div>
                                                        <label className="text-black font-w400 fs-7">{person.name}</label>
                                                        <div className="d-block">
                                                            <label className="fs-8 text-dark">{person.phone_number}</label>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                {person.promise.map((val, j) => {
                                                    // Define color based on status
                                                    const status = person.promise_status[j];
                                                    let bgColor = '#B0BEC5'; // default No Promise

                                                    if (status === 1) bgColor = '#D32F2F'; // Promise Breaker
                                                    else if (status === 2) bgColor = '#F9A825'; // Promise In Motion
                                                    else if (status === 3) bgColor = '#43A047'; // Promise Keeper

                                                    return (
                                                        <td key={j} className="min-w-80px px-1 text-center">
                                                            <div className="d-flex flex-column gap-2 align-items-center">
                                                                {/* Promise Count */}
                                                                <label
                                                                className="py-1 px-2 text-white rounded"
                                                                style={{ backgroundColor: '#4DB6AC' }}
                                                                >
                                                                <span>{val.toString().padStart(2, '0')}</span>
                                                                </label>

                                                                {/* Converted Count */}
                                                                <label
                                                                className="py-1 px-2 text-black rounded"
                                                                style={{ backgroundColor: bgColor }}
                                                                >
                                                                <span>{person.promise_achiever[j].toString().padStart(2, '0')}</span>
                                                                </label>
                                                            </div>
                                                            </td>
                                                    )
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div >
        </Modal >
    );
};

export default TeamComparison;
